import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';

export default function TimeOfUse({ slots }: { slots: any[] }) {
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const currency=useCurrency();
  const getSlotForHour = (hour: number) => {
    return slots.find((s: any) => {
      const formatTimeStr = (t: any) => {
        if (!t) return "00:00";
        if (typeof t === 'string' && t.includes(':')) return t;
        const num = Number(t) || 0;
        const hours = Math.floor(num);
        const minutes = Math.round((num - hours) * 60);
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
      };

      const startStr = formatTimeStr(s.start_time ?? s.startTime);
      const endStr = formatTimeStr(s.end_time ?? s.endTime);
      
      const fromParts = startStr.split(':');
      const toParts = endStr.split(':');
      
      const fromHour = parseInt(fromParts[0], 10);
      const fromMinute = parseInt(fromParts[1], 10);
      const toHour = parseInt(toParts[0], 10);
      const toMinute = parseInt(toParts[1], 10);
      
      let isCovered = false;
      
      if (fromHour <= toHour) {
         if (hour > fromHour && hour < toHour) {
           isCovered = true;
         } else if (hour === fromHour && hour === toHour) {
           if (toMinute > fromMinute) isCovered = true;
         } else if (hour === fromHour) {
           isCovered = true;
         } else if (hour === toHour && toMinute > 0) {
           isCovered = true;
         }
      } else {
         // Cross midnight
         if (hour >= fromHour || hour < toHour || (hour === toHour && toMinute > 0)) {
           isCovered = true;
         }
      }
      
      return isCovered;
    });
  };

  return (
    <div className="space-y-6">
      {/* Timeline */}
      <div className="flex w-full overflow-hidden rounded-md border border-slate-200">
        {hours.map((hour) => {
          const slot = getSlotForHour(hour);
          const color = slot?.color || '#e2e8f0';
          return (
            <div
              key={hour}
              className="relative flex-1 border-r border-white last:border-r-0 py-2.5 text-center text-xs font-semibold text-slate-700"
            >
              <div className="absolute inset-0 opacity-20" style={{ backgroundColor: color }} />
              <span className="relative z-10">{String(hour).padStart(2, '0')}</span>
            </div>
          );
        })}
      </div> 

      {/* List */}
      <div className="rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-50 text-xs font-bold text-slate-500">
            <tr>
              <th className="px-6 py-4 tracking-wider">Slot</th>
              <th className="px-6 py-4 tracking-wider">Hours</th>
              <th className="px-6 py-4 text-right tracking-wider">Rate</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {slots.map((slot: any, index: number) => {
              const formatTimeStr = (t: any) => {
                if (!t) return "00:00";
                if (typeof t === 'string' && t.includes(':')) return t;
                const num = Number(t) || 0;
                const hours = Math.floor(num);
                const minutes = Math.round((num - hours) * 60);
                return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
              };
              const start = formatTimeStr(slot.start_time ?? slot.startTime ?? 0);
              const end = formatTimeStr(slot.end_time ?? slot.endTime ?? 0);
              return (
                <tr key={index}>
                  <td className="px-6 py-4 font-semibold text-slate-800">
                    <div className="flex items-center gap-3">
                      <div
                        className="h-3.5 w-3.5 rounded-[4px]"
                        style={{ backgroundColor: slot.color || '#cbd5e1' }}
                      />
                      {slot.name || slot.slotName || 'Slot'}
                    </div>
                  </td>
                  <td className="px-6 py-4 font-mono text-sm font-semibold text-slate-500">
                    {start} &rarr; {end}
                  </td>
                  <td className="px-6 py-4 text-right font-bold text-slate-800">
                    {currency} {slot.rate} <span className="font-semibold text-slate-400 ml-1">{slot.unit}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
